import 'antd/dist/antd.css'
import './styles/tailwind.css'
import { config } from '@tshared/config/config.ts'
import ReactDOM from 'react-dom/client'

import { QueryClientProvider } from './containers/QueryClientProvider.tsx'
import { useUserStore } from './tshared/stores/user-session.store.ts'
import { SingleInstanceGuard } from './utils/check-single-instance.ts'

// shared config setup
config.setApiBase(import.meta.env.VITE_API_BASE)
config.setHeaderHost('arc')
useUserStore.setState({
  onRefreshTokenError: () => {
    window.location.replace('/auth/sign-in')
  },
})
config.setSaveKv(async (key, value) => {
  localStorage.setItem(key, value)
})
config.setLoadKv(async (key: string) => {
  return localStorage.getItem(key) ?? JSON.stringify(null)
})

console.log('API Base:', config.getApiBase())

// single instance guard
new SingleInstanceGuard({
  restrictedPaths: ['/arc'], // Only restrict single instance under / path
  onSecondInstance: () => {
    alert('Cannot open multiple instances of the application.')
    window.location.replace('about:blank')
  },
})

// render app
const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)

  root.render(<QueryClientProvider />)
}
